import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RxComposite } from '../model/rx-composite';
import { rxRequiredValidator } from '@nrwl/rx-validators';
import { RxInputModule } from '@nrwl/rx-input';
import { CommonModule } from '@angular/common';
import { RxFormControlErrorsModule } from '@nrwl/rx-form-errors';

@Component({
  selector: 'rx-password-form',
  templateUrl: './rx-password-form.component.html',
  styleUrls: ['./rx-password-form.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxInputModule,
    RxFormControlErrorsModule,
  ],
})
export class RxPasswordFormComponent extends RxComposite implements OnInit, OnDestroy {
  public registerForm: FormGroup;
  public mustNotMatchError = {
    mustNotMatch: 'The new password must not match the current password',
  };
  public mustMatchError = {
    mustMatch: 'The new password and the confirm password must be the same',
  };

  constructor(private fb: FormBuilder) {
    super();
  }

  public ngOnInit() {
    this.registerForm = this.fb.group(
      {
        oldPassword: ['', [rxRequiredValidator]],
        newPassword: ['', [rxRequiredValidator, Validators.minLength(6)]],
        confirmPassword: ['', [rxRequiredValidator, Validators.minLength(6)]],
      },
      {
        validators: [
          this.mustMatch('newPassword', 'confirmPassword'),
          this.mustNotMatch('oldPassword', 'newPassword'),
        ],
      },
    );

    this.subscribeOnChange();
  }

  public ngOnDestroy() {}

  public subscribeOnChange() {
    this.registerForm.valueChanges.subscribe((res: any) => {
      if (this.registerForm.invalid) {
        this.payload.password = null;
        return;
      }

      this.payload.password = {
        current_password: res.oldPassword,
        password: res.newPassword,
      };
    });
  }

  /**
   *
   * helpers validators
   */

  /**
   * Validation that confirm password and new password must match
   */
  private mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  /**
   * Validation that new password and old password must not match
   */
  private mustNotMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustNotMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      if (control.value === matchingControl.value) {
        matchingControl.setErrors({ mustNotMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
